// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d94ef149","703":"8aed521d"}[chunkId] + ".chunk.js";
};